const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Montserrat
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat',
    name: 'montserrat-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Montserrat',
      description:
        " Personnalise tes créations ultra facilement avec le set de tampons alphabet Montserrat ! <br/> Avec ses lettres droites et élégantes, la police d'écriture Montserrat est à la fois moderne et épurée.",
      tags: ['set-tampon-alphabet-montserrat'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/montserrat/set-complet-montserrat.jpg'),
          name: 'Montserrat',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/set-complet-montserrat',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/montserrat/montserrat-majuscules.jpg'),
          name: 'Montserrat',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/majuscules-montserrat',
        },
        {
          src: require('../../../public/img/materiel-creatif/montserrat/montserrat-minuscules.jpg'),
          name: 'Montserrat',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/minuscules-montserrat',
        },
        {
          src: require('../../../public/img/materiel-creatif/montserrat/montserrat-speciaux.jpg'),
          name: 'Montserrat',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/speciaux-chiffres-montserrat',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/set-complet-montserrat',
    name: 'full-set-montserrat',
    component: () =>
      import('../../pages/products/creative/Montserrat/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/montserrat/set-complet-montserrat.jpg'),
      type: 'Set complet Montserrat',
      hiddenType: 'montserrat-stamps',
      description: 'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-montserrat'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/majuscules-montserrat',
    name: 'uppercase-montserrat',
    component: () =>
      import('../../pages/products/creative/Montserrat/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/montserrat/montserrat-majuscules.jpg'),
      type: 'Jeu de majuscules Montserrat',
      hiddenType: 'montserrat-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-montserrat'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/minuscules-montserrat',
    name: 'lowercase-montserrat',
    component: () =>
      import('../../pages/products/creative/Montserrat/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/montserrat/montserrat-minuscules.jpg'),
      type: 'Jeu de minuscules Montserrat',
      hiddenType: 'montserrat-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-montserrat'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-montserrat/speciaux-chiffres-montserrat',
    name: 'specials-numbers-montserrat',
    component: () =>
      import('../../pages/products/creative/Montserrat/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/montserrat/montserrat-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Montserrat',
      hiddenType: 'montserrat-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-montserrat'],
    },
  },
];
